import { Col, Row } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import "./index.css";
import styles from "./index.module.css";

export const AuthLayout = () => {
  const location = useLocation();

  return (
    <Row className="auth-layout">
      <Col xs={24} lg={12} className="auth-left">
        <div className={styles.authLayoutBg}>
          <img src="/Background_pattern_decorative.webp" />
        </div>
        <div key={location.pathname} className={styles.outletContainer}>
          <Outlet />
        </div>
      </Col>
      <Col xs={0} lg={12} className="auth-right">
        <div className="auth-image"></div>
      </Col>
    </Row>
  );
};
